<template>
  <div class="cd-widget">
    <div class="cd-donut" :style="donutStyle">
      <span class="cd-value">{{ value }}%</span>
    </div>
    <!-- <p class="cd-label">{{ $t('dash.presenceManagement.table.completionLabel') }}</p> -->
  </div>
</template>

<script>
export default {
  name: 'completion-donut',

  props: {
    value: {
      type: Number,
      default: 0
    },
    band: {
      type: String,
      default: 'low'
    }
  },

  computed: {
    bandColor() {
      if (this.band === 'full') return '#6a1f4c'
      if (this.band === 'medium') return '#B64985'
      return '#d9b3ca'
    },

    donutStyle() {
      const pct = Math.max(0, Math.min(100, this.value || 0))
      return {
        background: `conic-gradient(${this.bandColor} ${pct}%, #e8dff0 ${pct}% 100%)`
      }
    }
  }
}
</script>

<style scoped>
.cd-widget {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.cd-donut {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* White inner ring to create the donut effect */
.cd-donut::before {
  content: '';
  position: absolute;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
}

.cd-value {
  position: relative;
  z-index: 1;
  font-size: 10px;
  font-weight: 800;
  color: #6a1f4c;
  line-height: 1;
}

.cd-label {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  color: #B64985;
  color: #121826;
  line-height: 1;
}
</style>
